function vueSlideshow(sectionID,_count,interval,slides) {
    const filterSlidesBySchedule = (slides) => {
        const now = new Date();
        return (slides || []).filter((slide) => {
            const dtRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
            if (slide.startDatetime) {
                if (!dtRegex.test(slide.startDatetime)) return false;
                const start = new Date(slide.startDatetime.replace(' ', 'T'));
                if (now < start) return false;
            }
            if (slide.endDatetime) {
                if (!dtRegex.test(slide.endDatetime)) return false;
                const end = new Date(slide.endDatetime.replace(' ', 'T'));
                if (now > end) return false;
            }
            return true;
        });
    };
    const activeSlides = filterSlidesBySchedule(slides);
    const desktopSlides = activeSlides.filter((slide) => {
        return !!(slide?.desktopImageURL || slide?.desktopVideo?.primeSource?.url);
    });
    const mobileSlides = activeSlides.filter((slide) => {
        return !!(slide?.mobileImageURL || slide?.mobileVideo?.primeSource?.url);
    });
    dynamicSlideshow[sectionID] = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const activeSlide = Vue.ref(0)
            const isMobileView = Vue.ref(window.matchMedia('(max-width: 749px)').matches)

            const timer = Vue.ref(false)

            const desktopSlideArray = Vue.ref(desktopSlides)
            const mobileSlideArray = Vue.ref(mobileSlides)
            const slideArray = Vue.computed(() => isMobileView.value ? mobileSlideArray.value : desktopSlideArray.value)
            const activeCount = Vue.computed(() => Math.max(slideArray.value.length - 1, 0))

            const nextSlide = (slideIndex) => {
                if (typeof slideIndex === 'number') {
                    activeSlide.value = slideIndex
                } else if (activeSlide.value < activeCount.value) {
                    activeSlide.value = activeSlide.value + 1;
                } else {
                    activeSlide.value = 0
                }
            }

            const prevSlide = () => {
                if (activeSlide.value > 0) {
                    activeSlide.value = activeSlide.value - 1;
                } else {
                    activeSlide.value = activeCount.value
                }
            }

            const slideHover = () => {
                clearInterval(timer.value)
            }

            const runTimer = () => {
                timer.value = setInterval(() => {
                    nextSlide()
                }, interval * 1000)
            }

            Vue.onMounted(() => {
                window.addEventListener('resize', () => {
                    isMobileView.value = window.matchMedia('(max-width: 749px)').matches
                    if (activeSlide.value > activeCount.value) activeSlide.value = 0
                })
                runTimer()
            })

            return {
                activeSlide, nextSlide, slideArray, desktopSlideArray, mobileSlideArray, slideHover, runTimer, prevSlide
            };
        }
    })
}
